import(/* webpackMode: "eager" */ "/home/ubuntu/Webkorps-Website/src/assets/images/benefits-of-fintech-software.jpg");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Webkorps-Website/src/assets/images/benefits-of-healthcare-software.jpg");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Webkorps-Website/src/assets/images/benefits-of-logistics-software.jpg");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Webkorps-Website/src/assets/images/benefits-of-real-estate-software.jpg");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Webkorps-Website/src/assets/images/benefits-of-retail-software.jpg");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Webkorps-Website/src/assets/images/benefits-of-travel-and-hospitality-software.jpg");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Webkorps-Website/src/assets/images/benefits-of-warehouse-management-software.jpg");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Webkorps-Website/src/assets/images/fintech-software-development-services.jpg");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Webkorps-Website/src/assets/images/healthcare-software-development-services.jpg");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Webkorps-Website/src/assets/images/logistics-software-development-services.jpg");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Webkorps-Website/src/assets/images/real-estate-software-development-services.jpg");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Webkorps-Website/src/assets/images/retail-software-development-services.jpg");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Webkorps-Website/src/assets/images/travel-and-hospitality.jpg");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/Webkorps-Website/src/assets/images/warehouse-management-software-development-services.jpg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/Webkorps-Website/src/components/pages/IndustryPage.jsx");
